import React, { Component } from 'react';
export default class About extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="about">
         <div className="row">

            <div className="three columns wow fadeInLeft" data-wow-delay=".25s" data-wow-offset="50">

               {
                 resumeData.aboutme && resumeData.aboutme.map(item =>{
                   return(
                   <img key={item.url} className="profile-pic"  src={`${resumeData.imagebaseurl}${item.url}`} alt="" />
                            )
                          }
                    )
                  }

            </div>
            {
              resumeData.aboutme && resumeData.aboutme.map(item =>{
                return (
            <div className="nine columns main-col" key={item.sectionTitle}>
                  <h2 className="wow fadeInRight" data-wow-delay=".25s" data-wow-offset="50" >{item.sectionTitle}</h2>
                  <p className="wow fadeIn" data-wow-delay="1s">{item.bio}</p>
            </div>
              )}
           )}
         </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/about/about.js